import React from "react";
import LocalSeoPage from "./LocalSeoPage";

export default function NumerologieMontelimarPage() {
  return (
    <LocalSeoPage
      path="/numerologie-montelimar"
      service={{
        name: "Numérologie",
        slug: "numerologie",
        shortName: "la numérologie",
        kicker: "Numérologie à Montélimar (Drôme)",
        h1: "Numérologie à Montélimar — Décrypte ton chemin de vie et tes cycles",
        lead:
          "Ton prénom, ta date de naissance et ton nom recèlent une carte précise de qui tu es et de ce que tu es venu vivre. Reçois ton bilan numérologique sous forme de PDF envoyé par mail — une vraie boussole pour comprendre tes forces, tes défis et les cycles qui rythment ta vie.",
        image: "https://www.bilan2vie.fr/og-numerologie.jpg",
        priceFrom: 35,
        aboutTitle: "Qu'est-ce que la numérologie ?",
        audienceTitle: "À qui s'adresse un bilan numérologique à Montélimar ?",
      }}
      meta={{
        title: "Numérologie à Montélimar — Bilan numérologique PDF à 35€ | Bilan 2 Vie",
        description:
          "Bilan numérologique complet à 35€, envoyé en PDF par mail après réservation. Chemin de vie, objectif de vie, défis, cycles karmiques et profil astrologique (solaire, ascendant, lunaire). Service 100 % à distance.",
        keywords:
          "numérologie Montélimar, numérologue Montélimar, bilan numérologique PDF, chemin de vie, cycles karmiques, numérologie à distance, numérologie en ligne, bilan numérologique 35€",
      }}
      about={[
        "La numérologie est une science symbolique millénaire qui considère que chaque chiffre porte une vibration et un sens. À partir de ta date de naissance complète (jour, mois, année) et de ton nom de naissance, on calcule plusieurs nombres clés : chemin de vie, nombre d'expression, nombre intime, nombre de réalisation, année personnelle… Chacun éclaire une facette différente de ton existence.",
        "Le chemin de vie est le nombre le plus connu : il révèle la grande mission de ton existence, les leçons que tu es venu apprendre et les défis qui jalonneront ton parcours. Mais réduire la numérologie au seul chemin de vie serait dommage : un bilan complet ouvre une cartographie beaucoup plus riche, avec des cycles karmiques et des passages-clés tout au long de ta vie.",
        "Le bilan numérologique n'est pas quelque chose de complet en soi — c'est un excellent point de départ, une boussole pour mieux te connaître. Si tu veux aller plus loin sur certains sujets précis (amour, carrière, choix à venir), une consultation de voyance ou un Bilan de Vie sera plus indiqué pour creuser en profondeur.",
        "Je te propose une formule simple et accessible : tu réserves en ligne, tu m'envoies tes informations (date et lieu de naissance, nom complet), et je te prépare ton bilan numérologique en PDF que tu reçois directement par mail. Aucune visio, aucun rendez-vous à caler : tu lis ton bilan à ton rythme, et tu reviens vers moi si tu souhaites une consultation pour approfondir un point.",
      ]}
      audience={[
        "Tu veux mieux comprendre ta personnalité profonde et tes forces naturelles.",
        "Tu sens que ta vie suit des cycles et tu cherches à les décoder.",
        "Tu es à un tournant (30, 40, 50 ans) et tu veux y voir clair.",
        "Tu te demandes quelle est ta véritable mission de vie.",
        "Tu veux croiser ton chemin de vie avec ton signe astrologique solaire, ascendant et lunaire.",
        "Tu hésites sur une reconversion ou un grand changement à venir.",
        "Tu cherches une première lecture spirituelle, simple et abordable, avant d'envisager une consultation plus poussée.",
        "Tu vis loin de Montélimar : aucun problème, tout se fait à distance.",
      ]}
      steps={[
        {
          title: "Réservation en ligne",
          desc:
            "Tu réserves ton bilan numérologique directement sur le site (35 €). Le paiement est sécurisé et immédiat.",
        },
        {
          title: "Tu m'envoies tes informations",
          desc:
            "Date de naissance complète, lieu de naissance et nom de naissance (celui de ton acte de naissance). Tout est confidentiel et utilisé uniquement pour préparer ton bilan.",
        },
        {
          title: "Décodage de ton âme",
          desc:
            "Tu reçois ton bilan numérologique par mail au format PDF. Tu y trouveras : ton chemin de vie, ton objectif de vie, tes défis, tes cycles karmiques, ainsi que le descriptif de ton signe astrologique solaire, ascendant et lunaire.",
        },
        {
          title: "Tu lis à ton rythme",
          desc:
            "Le PDF reste ta boussole pour les années à venir. Tu peux le relire à chaque tournant important, et revenir vers moi pour une consultation de voyance si tu veux creuser un sujet précis.",
        },
      ]}
      reasons={[
        "Numérologue passionnée, je pratique la spiritualité depuis 2015 et j'en ai fait mon métier depuis 2021. Ma spécialité : croiser numérologie, voyance et médiumnité pour une analyse à 360°.",
        "Bilan complet qui croise numérologie ET astrologie (signes solaire, ascendant, lunaire) : tu obtiens une vraie photographie énergétique de qui tu es.",
        "Cabinet basé à Montélimar (20 quai du Roubion) — pour les bilans, tout se fait à distance, mais tu peux ensuite venir en cabinet pour une consultation de voyance afin d'approfondir.",
        "Tu reçois ton bilan en PDF directement par mail après réservation, à conserver et relire pour les années suivantes.",
        "Service 100 % à distance : tu peux réserver depuis n'importe où en France ou à l'étranger, à n'importe quel moment.",
      ]}
      faqs={[
        {
          q: "Quelle est la différence entre numérologie et astrologie ?",
          a: "Les deux disciplines décodent les énergies d'une personne. L'astrologie utilise la position des planètes à ta naissance, tandis que la numérologie utilise les vibrations des chiffres issus de ta date de naissance et de ton nom. Mon bilan combine les deux : tu obtiens à la fois ton chemin numérologique ET ton profil astrologique (signe solaire, ascendant, lunaire) dans un seul document.",
        },
        {
          q: "Faut-il utiliser mon nom de jeune fille ou mon nom marital ?",
          a: "Pour les calculs structurants (chemin de vie, nombre d'expression), on utilise toujours le nom de naissance, celui inscrit sur ton acte de naissance. Le nom marital peut être analysé en complément pour comprendre l'énergie de ta vie de couple — n'hésite pas à me préciser les deux si tu le souhaites.",
        },
        {
          q: "Combien de temps un bilan numérologique reste-t-il valable ?",
          a: "La structure de base (chemin de vie, nombres principaux, signes astrologiques) ne change jamais : c'est pour la vie. Les cycles, eux, évoluent. Une mise à jour tous les 3 à 5 ans est utile pour rester aligné avec ton année personnelle et tes cycles courts.",
        },
        {
          q: "Peut-on faire un bilan pour son enfant ?",
          a: "Oui, et c'est même très puissant. Comprendre la numérologie de ton enfant t'aide à l'accompagner dans ses talents naturels et ses défis, plutôt que de projeter sur lui ce que toi tu attends. Réservé aux mineurs accompagnés d'un parent qui valide la demande.",
        },
        {
          q: "Combien coûte un bilan numérologique ?",
          a: "Le bilan numérologique complet (incluant chemin de vie, objectif de vie, défis, cycles karmiques et profil astrologique solaire/ascendant/lunaire) est proposé à 35 €. Le PDF te parvient par mail après réservation.",
        },
        {
          q: "Le bilan numérologique remplace-t-il une consultation de voyance ?",
          a: "Non, il la complète. Le bilan numérologique est une excellente première étape — une boussole pour mieux te connaître. Mais si tu veux des réponses précises sur des questions spécifiques (amour, carrière, choix à venir), une consultation de voyance sera plus indiquée. Beaucoup de mes clients commencent par le bilan numérologique puis enchaînent avec une consultation pour creuser.",
        },
        {
          q: "Le bilan est-il faisable en cabinet ?",
          a: "Non, le bilan numérologique est uniquement à distance : tu le reçois par mail au format PDF après réservation. En revanche, tu peux venir en cabinet à Montélimar pour une consultation de voyance qui s'appuiera sur ton bilan numérologique.",
        },
      ]}
      blogCategory="Pratiques Ésotériques"
    />
  );
}
